import { render, staticRenderFns } from "./douyin_count.vue?vue&type=template&id=329efddb&scoped=true"
import script from "./douyin_count.vue?vue&type=script&lang=js"
export * from "./douyin_count.vue?vue&type=script&lang=js"
import style0 from "./douyin_count.vue?vue&type=style&index=0&id=329efddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329efddb",
  null
  
)

export default component.exports